import { FiLogOut, FiMenu } from "react-icons/fi";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

const DashboardHeader = ({ onMenuClick }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <header className="sticky top-0 z-30 flex h-14 sm:h-16 items-center justify-between border-b border-[#a6a6a6]/30 bg-white px-4 sm:px-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Hap menunë"
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-[#000000] hover:bg-[#e0d8c3]/30 md:hidden"
        >
          <FiMenu size={22} />
        </button>
        <h1 className="text-base sm:text-lg font-semibold text-[#000000] truncate">
          Aura Parfumes – Admin
        </h1>
      </div>

      <button
        type="button"
        onClick={handleLogout}
        className="flex min-h-[44px] items-center gap-2 rounded-lg bg-[#000000] px-3 sm:px-4 py-2 text-sm font-medium text-[#ffffff] hover:bg-[#000000]/90 transition touch-manipulation"
      >
        <FiLogOut size={18} />
        <span className="hidden sm:inline">Dil</span>
      </button>
    </header>
  );
};

export default DashboardHeader;
